// extracted by mini-css-extract-plugin
module.exports = {"header":"OverflowContainer_header__1gTar","scroll":"OverflowContainer_scroll__2wrsV","wrapper":"OverflowContainer_wrapper__12zHp"};